/* eslint-disable no-unused-vars */
import { setContext } from '@apollo/client/link/context';
import { ApolloClient, InMemoryCache, createHttpLink, from, split } from '@apollo/client';
import { getMainDefinition } from '@apollo/client/utilities';
import { WebSocketLink } from '@apollo/client/link/ws';
import { GRAPHQL_WS_ENABLED, HOST_API, WS_GRAPHQL } from '../config';

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

const httpLink = createHttpLink({
  uri: HOST_API,
});

const getConnectionParams = () => {
  const token = localStorage.getItem('accessToken');
  return token ? { authorization: `Bearer ${token}` } : {};
};

const wsLink = GRAPHQL_WS_ENABLED
  ? new WebSocketLink({
      uri: WS_GRAPHQL,
      options: {
        lazy: true,
        reconnect: false,
        connectionParams: getConnectionParams,
      },
    })
  : null;

const splitLink =
  wsLink &&
  split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    },
    wsLink,
    httpLink
  );

export const client = new ApolloClient({
  link: from([authLink.concat(splitLink || httpLink)]),
  cache: new InMemoryCache(),
});
